import { render } from "./AdminWorkspace.vue?vue&type=template&id=f5f6d106&scoped=true"
import script from "./AdminWorkspace.vue?vue&type=script&lang=js"
export * from "./AdminWorkspace.vue?vue&type=script&lang=js"

import "./AdminWorkspace.vue?vue&type=style&index=0&id=f5f6d106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f6d106"]])

export default __exports__